import React from "react";
import { Grid, styled } from "@mui/material";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { IFlight } from "@vmosolutions/oc-interfaces";
import { openModal, closeModal } from "src/redux/actions/App.Actions";
import { FlightChip, IFlightChip } from "./FlightChip";

interface IDeletableFlightChipProps {
  data?: IFlightChip;
  //className?: string;
  onClickChip?: (flightId: string) => void;
  handleDelete: (flightId: string) => void;
}

const OCDeletableFlightChip = styled(Grid)(({ theme }) => ({
  width: 150,
  marginLeft: 25,
}));

export const DeletableFlightChip = (props: IDeletableFlightChipProps): JSX.Element => {
  const dispatch = useDispatch();
  const [isOver, setIsOver] = React.useState<boolean>(false);
  const { data, onClickChip, handleDelete } = props;
  /**
   * Calls the useCallback to handle delete of flight chip
   * @param flightId- flightId
   */
  const handleSendRemove = (flightId: string): void => {
    dispatch(
      openModal({
        root: {
          data: {
            title: `Remove Flight ${data.flightNumber}?`,
            message: "Are you sure you wish to proceed?",
            buttons: [
              {
                label: "CANCEL",
                handler: () => {
                  dispatch(closeModal({ root: { data: null } }));
                },
              },
              {
                label: "OK",
                handler: () => {
                  handleDelete(flightId);
                  dispatch(closeModal({ root: { data: null } }));
                },
              },
            ],
          },
        },
      })
    );
  };

  return (
    <OCDeletableFlightChip
      key={`${data?._id}-deletable`}
      container
      direction="row"
      onMouseEnter={() => setIsOver(true)}
      onMouseLeave={() => setIsOver(false)}
    >
      <FlightChip data={data} onClickChip={onClickChip} />
      {isOver ? <CloseIcon onClick={() => handleSendRemove(data._id)} /> : null}
    </OCDeletableFlightChip>
  );
};

/**
 * Takes in id to update contents if delete clicked
 * @param flightId - id to search content flights
 */
export const updateRemove = (flightId: string, contentFlights: IFlight[]): IFlight[] => {
  return contentFlights.filter((flight) => flight._id !== flightId);
};
